<template>
  <div>
    <PageAllow controller="StockInOrders" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>

            <v-col>
              <v-btn
                v-if="
                  pageType == 1 &&
                  $permission.permissionAllow('StockInOrders', 'add')
                "
                small
                color="primary"
                class="ms-1 float-end"
                @click="checkActions()"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("stockInOrders.ObjectName")]) }}
              </v-btn>
              <!-- 采购入库 -->
              <v-btn
                v-if="
                  pageType == 1 &&
                  $permission.permissionAllow('StockInOrders', 'importPurchase')
                "
                small
                color="primary"
                class="ms-1 float-end"
                @click="stockDialog = true"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("CurrentStocks.exportStock") }}
              </v-btn>
              <v-tooltip
                v-if="$permission.permissionAllow('StockInOrders', 'export')"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 float-end"
                    @click.stop="exportExcel()"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("stockInOrders.export") }}
                  </v-btn>
                </template>
                <span>{{ $t("stockInOrders.export") }}</span>
              </v-tooltip>
              <v-tooltip
                v-if="$permission.permissionAllow('StockInOrders', 'view')"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 float-end"
                    @click.stop="doPrint('stockOrdersInPrint')"
                  >
                    <v-icon x-small class="pe-1">fa-print</v-icon>
                    {{ $t("stockInOrders.print") }}
                  </v-btn>
                </template>
                <span>{{ $t("stockInOrders.print") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_order_code"
                  v-model="options.stock_order_code"
                  @text="stockInsKeyWord = $event"
                  :label="$t('stockInOrders.stockInKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="pageType == 1">
                <v-select
                  v-model="stockInsTypeSelected"
                  clearable
                  :items="$consts.stock_in_order.types"
                  :label="$t('stockInOrders.Fields.stock_in_type')"
                >
                </v-select>
              </v-col>
              <!-- 商品编码 -->
              <SearcherKeyword
                ref="material_code"
                v-model="options.material_code"
                @text="materialCode = $event"
                :label="
                  $t('stockInOrders.DetailFields.material_code') +
                  '/' +
                  $t('stockInOrders.DetailFields.material_name')
                "
              />
              <!-- 对象名称 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="stockInsTypeSelected == 6 || stockInsTypeSelected == 11"
              >
                <SearcherKeyword
                  ref="keyword"
                  v-model="options.keyword"
                  @text="KeyWord = $event"
                  :label="$t('stockInOrders.Keyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('stockInOrders.status.title')"
                  :items="[
                    $consts.stock_in_order.status[1],
                    $consts.stock_in_order.status[2],
                  ]"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_ins"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.stock>
            {{ $t("stockInOrders.default_stock_name") }}
          </template>
          <template v-slot:item.stock_name="{ item }">
            {{
              item.type == 11
                ? item.supplier_name
                : item.type == 2
                ? item.account_stock_name
                : item.stock_name
            }}
          </template>
          <!-- 出库单编号/创建时间 -->
          <template v-slot:item.stock_order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.total_price="{ item }">
            <span>
              {{ item.total_price | formatMoney }}
            </span>
          </template>
          <!-- 状态 -->
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | stockOrderINStatusColor"
              :text-color="item.status | stockOrderINStatusTextColor"
            >
              {{ item.status | stockOrderINStatusText }}
              <!-- <span
                v-if="
                  item.third_return && item.third_return.push_platform == 1010
                "
              >
                ({{ item.third_return.status | stockOrderOUTThirdStatusText }})
              </span> -->
            </v-chip>
            <br />
            <v-chip
              v-if="item.cancel_flg"
              x-small
              label
              outlined
              color="danger"
            >
              {{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
          <!-- 完成时间 -->
          <template v-slot:item.finish_time="{ item }">
            {{
              item.type == 3
                ? item.actual_finish_time
                : item.finish_time | formatTime
            }}
          </template>
          <template v-slot:item.actions="{ item }">
            <StockOrderOUTActions
              :pageType="pageType"
              :stock_in="item"
              showView
              showExport
              :status="item.status"
              :showEdit="item.actions.in_edit"
              :showCancel="item.actions.out_cancel"
              :showComplete="item.actions.out_complete"
              @done="getStockInsFromAPI()"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <ImportExcelAlert
      v-model="stockDialog"
      :title="$t('stockInOrders.StockMaterial')"
      :template="$t('stockInOrders.template')"
      :upload="$t('stockInOrders.upload')"
      :objName="$t('stockInOrders.InitializeMaterial')"
      :temData="{
        product_date_setting:
          (accountSettings && accountSettings.product_date_setting) == 1
            ? accountSettings.product_date_setting
            : 0,
      }"
      @import="
        excelStockFile = $event;
        importStockExcel();
      "
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import StockIns from "@/api/stock_in_orders";
import StockOrderOUTActions from "./plugins/Actions";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import Shops from "@/api/shops";
import ImportExcelAlert from "./plugins/ImportExcelAlert";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_order_code: "",
  material_code: "",
  status: [2, 3],
  cancel_flgs: [0],
  type: null,
};

const defaultProductionOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_order_code: "",
  material_code: "",
  status: [2, 3],
  cancel_flgs: [0],
  type: 7,
};

function getPageType() {
  return document.URL.endsWith("/production-stock-in") ? 2 : 1;
}
function getOptionPrefix() {
  switch (getPageType()) {
    default:
    case 1:
      return "stock-ins";
    case 2:
      return "production-stock-in";
  }
}
function getOptionSelects() {
  switch (getPageType()) {
    default:
    case 1:
      return ["stockInsTypeSelected"];
    case 2:
      return [];
  }
}
function getDefaultOptions() {
  switch (getPageType()) {
    default:
    case 1:
      return defaultOptions;
    case 2:
      return defaultProductionOptions;
  }
}

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockOrderOUTActions,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
    SearcherCancelFlgs,
    ImportExcelAlert,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text:
            this.pageType == 2
              ? i18n.t("Nav.productionManagement")
              : i18n.t("Nav.stockManagement"),
          disabled: false,
          href: this.pageType == 2 ? "/production-plans" : "/current-stocks",
        },
        {
          text:
            this.pageType == 2
              ? i18n.t("Nav.productionStockIN")
              : i18n.t("Nav.stockInOrders"),
          disabled: true,
          href:
            this.pageType == 2 ? "/production-stock-in" : "/stock-in-orders",
        },
      ];
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("stockInOrders.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("stockInOrders.Fields.actual_time"),
      },
    ],
    headers() {
      let headers = [
        {
          text:
            i18n.t("stockInOrders.Fields.stock_in_code") +
            " / " +
            i18n.t("stockInOrders.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
      ];
      if (this.pageType != 2) {
        headers.push({
          text: i18n.t("stockInOrders.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "stock_name",
        });
      }
      headers.push(
        {
          text: i18n.t("stockInOrders.Fields.stock_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "stock",
        },
        {
          text: i18n.t("stockInOrders.Fields.stock_in_type"),
          align: "start",
          sortable: false,
          value: "in_type_str",
        },
        {
          text: i18n.t("stockInOrders.Fields.detail_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "detail_count",
        },
        {
          text: i18n.t("stockInOrders.Fields.total_price"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "total_price",
        },
        {
          text: i18n.t("stockInOrders.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("stockInOrders.Fields.finish_time"),
          align: "start",
          sortable: false,
          value: "finish_time",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "stickTableCols", "accountSettings"]),
  },

  mounted() {
    this.$commonUtils.loadOptions(getOptionPrefix(), getOptionSelects()).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "stockInsTypeSelected":
              this.stockInsTypeSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  data: () => ({
    pageType: getPageType(),
    stockInsKeyWord: "",
    materialCode: "",
    KeyWord: "",
    stockInsTypeSelected: null,
    stock_ins: [],
    options: JSON.parse(
      sessionStorage.getItem(getOptionPrefix() + "-options")
        ? sessionStorage.getItem(getOptionPrefix() + "-options")
        : JSON.stringify(getDefaultOptions())
    ),
    paging: {},
    currentItemMode: null,
    currentItem: null,
    detailMode: false,
    error_order_id: [],
    excelStockFile: null,
    stockDialog: false,
  }),

  methods: {
    resetSearch() {
      this.stockInsTypeSelected = null;
      //重置options
      this.options = JSON.parse(JSON.stringify(getDefaultOptions()));
      //重置搜索框
      let clearArr = [
        this.$refs.stock_order_code,
        this.$refs.keyword,
        this.$refs.material_code,
      ];
      clearArr.forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_order_code: this.stockInsKeyWord,
        material_code: this.materialCode,
        keyword: this.KeyWord,
      });
    },
    getStockInsFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      StockIns.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_ins = response.data.stock_ins;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    checkActions() {
      Shops.checkAction(2).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.data.actions) {
              this.$router.push("/stock-in-orders/new");
            } else {
              this.$snackbar.error(i18n.t(response.data.data.msg));
            }
          }
        }.bind(this)
      );
    },
    importStockExcel() {
      this.$store.dispatch("fullscreenLoading");
      StockIns.materialImports(
        Number(this.accountSettings.product_date_setting),
        this.excelStockFile
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("stockInOrders.material")])
              );

              this.stockDialog = false;
              this.getStockInsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    exportExcel() {
      StockIns.exports(this.options);
    },
    doPrint(mode) {
      var options = JSON.parse(JSON.stringify(this.options));
      options.page = 1;
      options.itemsPerPage = this.$consts.limitAll;
      switch (mode) {
        case "stockOrdersInPrint":
          this.$router.push({
            path: "/print/stock-orders-in-print",
            query: options,
          });
          break;
      }
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        this.pageType = getPageType();
        this.$commonUtils
          .loadOptions(getOptionPrefix(), getOptionSelects())
          .then(
            function (data) {
              if (data.options) {
                this.options = data.options;
              } else this.resetSearch();

              data.selecteds.forEach((selected) => {
                switch (selected.key) {
                  case "stockInsTypeSelected":
                    this.stockInsTypeSelected = selected.value;
                    break;
                }
              });
            }.bind(this)
          );
      },
    },
    options: {
      deep: true,
      handler() {
        this.getStockInsFromAPI();
        sessionStorage.setItem(
          getOptionPrefix() + "-options",
          JSON.stringify(this.options)
        );
      },
    },
    stockInsTypeSelected: {
      handler() {
        if (this.stockInsTypeSelected != 11) {
          this.options.keyword = "";
        }
        this.options.type = this.stockInsTypeSelected
          ? this.stockInsTypeSelected
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-stockInsTypeSelected",
          JSON.stringify(this.stockInsTypeSelected)
        );
      },
    },
  },
};
</script>